import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';
// import { getDimensionFullName, getAreaFullName } from '../constants';

const CarrerasTopDescPage = ({ user, top, careers, background, number }) => {
  // const { TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4 } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  // const firstDimName = getDimensionFullName(TOP_DIM_1);
  // const secondDimName = getDimensionFullName(TOP_DIM_2);
  // const thirdDimName = getDimensionFullName(TOP_DIM_3);
  // const fourthDimName = getDimensionFullName(TOP_DIM_4);
  // const dimensions = [
  //   ...new Set([TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4].filter(Boolean))
  // ];
  // console.log({top})
  // console.log({ user });
  // const areaName = getAreaFullName(top);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>
            2.4.1. Carreras asociadas a las áreas de conocimiento de interés
          </h3>
          <p className='justified'>
            En el siguiente apartado te presentamos las carreras que mejor se
            ajustan a las áreas de conocimiento en las que mostraste un mayor
            interés.
          </p>
          <p className='justified'>
            Cómo verás, hay muchas opciones donde podrías desplegar tus
            intereses vocacionales. Ahora es importante que identifiques
            aquellas que te llaman más la atención y buscar más información
            sobre ellas. Por ejemplo, podrías:
          </p>

          <br />
          <div
            className='edu-bubble-group bg-edu-blue'
            style={{
              paddingBottom: '1rem',
              paddingTop: '0.85rem',
              marginBottom: '1rem'
            }}
          >
            <div className='bubble-heading' style={{ textAlign: 'left' }}>
              Investigar
            </div>
            <div>
              Sobre lo que hacen los profesionales de estas carreras, donde
              trabajan, qué tipo de actividades realizan, cuál es el nivel de
              empleabilidad, sus ingresos promedio, etc.
            </div>
          </div>

          <div
            className='edu-bubble-group bg-edu-green'
            style={{
              paddingBottom: '1rem',
              paddingTop: '0.85rem',
              marginBottom: '1rem'
            }}
          >
            <div className='bubble-heading' style={{ textAlign: 'left' }}>
              Revisar
            </div>
            <div>
              Identificar las instituciones (universidades, institutos o centros
              de formación) donde se imparten y sus mallas curriculares (los
              ramos de la carrera), para conocer qué se estudia en cada
              programa.
            </div>
          </div>

          <div
            className='edu-bubble-group bg-edu-yellow'
            style={{
              paddingBottom: '1rem',
              paddingTop: '0.85rem',
              marginBottom: '1rem'
            }}
          >
            <div className='bubble-heading' style={{ textAlign: 'left' }}>
              Visitar
            </div>
            <div>
              Universidades y participar en ferias vocacionales, charlas
              informativas o clases abiertas de la carrera.
            </div>
          </div>

          <div
            className='edu-bubble-group bg-edu-red'
            style={{
              paddingBottom: '1rem',
              paddingTop: '0.85rem',
              marginBottom: '1.5rem'
            }}
          >
            <div className='bubble-heading' style={{ textAlign: 'left' }}>
              Conversar
            </div>
            <div>
              Con profesionales que trabajen en esas áreas para conocer su
              experiencia. Si es posible, acompañar a profesionales de la
              carrera en un día de trabajo.
            </div>
          </div>

          {/* <ul className='text-list'>
            <li style={{ display: 'block', marginBottom: 4 }}>
              - <strong>Investigar</strong> sobre lo que hacen los profesionales
              de estas carreras, donde trabajan, qué tipo de actividades
              realizan
            </li>
            <li style={{ display: 'block', marginBottom: 4 }}>
              - <strong>Revisar</strong> las mallas curriculares (los ramos de
              la carrera) de diferentes instituciones para conocer qué se
              estudia en cada programa.
            </li>
            <li style={{ display: 'block', marginBottom: 4 }}>
              - <strong>Visitar</strong> universidades y participar en ferias
              vocacionales, charlas informativas o clases abiertas de la
              carrera.{' '}
            </li>
            <li style={{ display: 'block', marginBottom: 4 }}>
              - <strong>Conversar</strong> con profesionales que trabajen en
              esas áreas para conocer su experiencia. Si es posible, acompañar a
              profesionales de la carrera en un día de trabajo.
            </li>
            <li style={{ display: 'block', marginBottom: 4 }}>
              - Con la información recolectada, <strong>reflexionar</strong>{' '}
              sobre tus expectativas y habilidades en relación con cada opción.
            </li>
          </ul> */}

          <br />
          <br />
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-gray'>
              <p className='justified'>
                Este tipo de actividades te permitirá conocer mejor de qué se
                tratan las distintas carreras, podrás <strong>analizar</strong>{' '}
                de forma más informada cómo coinciden con tus expectativas e
                intereses, y <strong>reflexionar</strong> de forma más segura
                sobre tus distintas opciones antes de tomar una decisión.
              </p>
            </div>
          </div>

          {/* <p className='justified'>
            A continuación encontrarás un resumen de carreras en relación a tus
            preferencias:{'  '}
            {dimensions.map((dim, i) => {
              const isLast = i + 1 === dimensions.length;
              const isSemiLast = i + 1 === dimensions.length - 1;
              const separator = isSemiLast ? ' y ' : ', ';
              return (
                <span key={dim}>
                  <strong>{getDimensionFullName(dim)}</strong>
                  {isLast ? '.' : separator}
                </span>
              );
            })}
          </p> */}
          {/* <p className='justified'>
            En tu caso las {careers.length} áreas de conocimiento que más te
            atraen son:{'  '}
            {careers.map((career, i) => {
              const isLast = i + 1 === careers.length;
              const isSemiLast = i + 1 === careers.length - 1;
              const separator = isSemiLast ? ' y ' : ', ';
              return (
                <span key={career}>
                  <strong>{getAreaFullName(career)}</strong>
                  {isLast ? '.' : separator}
                </span>
              );
            })}
          </p> */}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default CarrerasTopDescPage;
